export default __webpack_public_path__ + "static/media/css.3ec32022.svg";